export type PortalBranding = {
  logoUrl?: string | undefined;
  logoDarkUrl?: string | undefined;
  faviconUrl?: string | undefined;
  primaryColor?: string | undefined;
  secondaryColor?: string | undefined;
  backgroundColor?: string | undefined;
  textColor?: string | undefined;
  brandName?: string | undefined;
  /** Optional partner footer when Logto branding is hidden (portal API may supply these later). */
  partnerPoweredByLabel?: string | undefined;
  partnerLogoUrl?: string | undefined;
  partnerDarkLogoUrl?: string | undefined;
  partnerWebsiteUrl?: string | undefined;
};

const setVariable = (name: string, value: string | undefined) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) {
    return;
  }
  document.documentElement.style.setProperty(name, trimmed);
};

export function applyPortalBrandingToCssVariables(branding: PortalBranding): void {
  setVariable('--portal-brand-primary', branding.primaryColor);
  setVariable('--portal-brand-secondary', branding.secondaryColor);
  setVariable('--portal-brand-bg', branding.backgroundColor);
  setVariable('--portal-brand-text', branding.textColor);

  // Logos are handled by the experience UI; we expose them as CSS vars so UI can pick them up.
  setVariable('--portal-brand-logo', branding.logoUrl);
  setVariable('--portal-brand-logo-dark', branding.logoDarkUrl);
  setVariable('--portal-brand-favicon', branding.faviconUrl);
  setVariable('--portal-brand-name', branding.brandName);
}
